import React from 'react';
import { CRAFT_ELEMENTS } from '../config/craftElements';
import { ActionsController } from './ActionsController';
import { getElementColor } from '../helper';
import { useFunnelColorTheme } from '../../redux/slices/mainData';
import { FUNNEL_THEME_KEYS } from '../../redux/interfaces/mainData';

interface Props {
  backgroundColor?: string;
  paddingTopClass: string;
  paddingBottomClass: string;
  dividerColor?: string;
  children?: any;
  showLine?: boolean;
}

export const DividerComponent = ({
  paddingTopClass,
  paddingBottomClass,
  children,
  backgroundColor,
  dividerColor,
  showLine,
  ...props
}: Props): React.ReactElement => {
  const theme = useFunnelColorTheme();
  const style = {
    background: showLine
      ? getElementColor(dividerColor, theme)
      : getElementColor(backgroundColor, theme),
    height: 1,
    width: '100%',
  };

  return (
    <ActionsController
      {...props}
      className={`flex justify-content-center container__add-wrapper ${paddingTopClass} ${paddingBottomClass}`}
      style={{
        backgroundColor: getElementColor(backgroundColor, theme),
      }}
    >
      <div style={style}></div>
    </ActionsController>
  );
};

export default DividerComponent;

const DividerComponentProps = {
  backgroundColor: FUNNEL_THEME_KEYS.BACKGROUND_COLOR,
};
DividerComponent.craft = {
  props: DividerComponentProps,
  name: CRAFT_ELEMENTS.DIVIDER,
};
